<div class="banner-subpage withbreadcrumbs" *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker)">
  <h2 class="bighead">Archived<span class="offerstatus">{{propertyCount}}</span></h2>
  <ul class="bread-crumbs">
    <li><a (click)="Validation.redirect('/')">Home</a><span style="padding:8px;">|</span></li>
    <li *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)">Properties<span style="padding:8px;">|</span></li>
    <li *ngIf="this.authService.IsUserRole(this.authService.UserRole.Broker)">B+E Research<span style="padding:8px;">|</span></li>
    <li>Archived</li>
  </ul>
  <div class="search-div advanced-search-div clearfix search-div-02 buy-page-advance-search">
    <my-property-search (propertySearchCriteria)="propertySearchCriteria($event)"></my-property-search>
  </div>
</div>
<div class="container container-lg section-margin min-heightcontainer p_1" *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker)">
  <div class="border-div table-fixed margin0">
    <div class="clearfix p-1" *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)">
      <div class="floatinghead floatinghead-xs clearfix">
        <div *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)" class="margin-bottom-15  margin-right-10 displayinlineblockdiv" style="float:left">
          <!--<label class="form-label">
              Bulk Actions
          </label>-->
          <label class="select">
            <select class="form-control" [(ngModel)]="selectedAction" (change)="onActionSelect($event,bulkAction,'panlestyle',CompOrArchive,AssignBroker,BulkDelete);" style="width:175px">
              <option value="0">Bulk Actions</option>
              <option value="1">Change Status</option>
              <!--<option value="2">Mark As Comp</option>-->
              <option value="6">Move to Live Listings</option>
            </select>
            <i></i>
          </label>
        </div>
        <div *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)  || this.authService.IsUserRole(this.authService.UserRole.Broker)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) " class="margin-bottom-15  margin-right-10 displayinlineblockdiv" style="float:left">
          <p style="margin: 5px 0 0 0" class="selected-rows-count be-tag-01" *ngIf="selectedRows?.length > 0">
            {{selectedRows?.length}} row{{selectedRows?.length == 1 ? '':'s'}} selected
            <a class="remove" tooltip="Remove Selection" href="javascript:void(0);" (click)="resetSelectedRows();"><i class="icofont icofont-close" aria-hidden="true"></i></a>
          </p>
        </div>

        <div class="rightside clearfix">
          <!--<label class="form-label">&nbsp;</label>-->
          <button class="right-btn btn-border margin-right-10 btn adduserbtn margin-bottom-15 pull-right" *ngIf="propertiesEx?.length !== 0 " (click)="exportToExcel();">Export To Excel</button>
          <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown pull-right" style="width:165px !important;">
            <mat-form-field>
              <mat-select placeholder="Select Columns"
                          [(ngModel)]="selectedColumns"
                          multiple>
                <mat-select-trigger>
                  <span>Select Columns</span>
                </mat-select-trigger>
                @for (column of tableColumns; track column) {
                <mat-option [value]="column.id" class="multi-dropdown-item">{{column.name}}</mat-option>
                }
                @if (tableColumns.length === 0) {
                <mat-option class="matoptionnodata" disabled>
                  Nothing found...
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions" *ngIf="dtOptions">
              <thead>
                <tr>
                  <!--<th class="remove" style="position:static; cursor:default" ng-disabled="true"></th>-->
                  <th class="remove" style="position:static; cursor:default" ng-disabled="true" [hidden]="!(this.authService.IsUserRole(this.authService.UserRole.Admin))&&!(this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))" data-orderable="false">
                    <label class="custom-checkbox withoutlabel">
                      <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>
                    </label>
                  </th>
                  <th data-orderable="false" [hidden]="!(this.authService.IsUserRole(this.authService.UserRole.Admin))&&!(this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))">Action</th>
                  <th [hidden]="true">Property Id</th>
                  <th class="property-name-column sticky-left z-100">Tenant Name</th>

                  <!--<th>Property Status</th>-->
                  <th [hidden]="hideColumn(1)">State</th>
                  <th [hidden]="hideColumn(2)" style="min-width:80px;">City</th>
                  <th [hidden]="hideColumn(3)">Broker</th>
                  <th [hidden]="hideColumn(4)">Status</th>
                  <!--<th>Selling/Asking Price</th>-->
                  <th [hidden]="hideColumn(5)">Asking Price</th>
                  <th [hidden]="hideColumn(6)">Rent NOI</th>
                  <th [hidden]="hideColumn(7)">Credit Rating</th>
                  <th [hidden]="hideColumn(8)">Cap Rate</th>
                  <th [hidden]="hideColumn(9)">Remaining Term</th>
                  <th [hidden]="hideColumn(10)">Lease Structure</th>
                  <th [hidden]="hideColumn(11)">Area (SQ FT)</th>
                  <th [hidden]="hideColumn(12)">Rank</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let prop of propertiesEx; let i=index">
                  <tr [class.portfoio-list]="prop.IsPortfolio">
                    <td [hidden]="!(this.authService.IsUserRole(this.authService.UserRole.Admin))&&!(this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))">
                      <label class="custom-checkbox withoutlabel">
                        <input type="checkbox" [(ngModel)]="prop.IsSelected" (change)="onCheckboxChange($event,prop.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
                      </label>
                    </td>
                    <td *ngIf="authService.Admin()||authService.SuperAdmin()" class="whitespacenowrap">
                      <a class="remove" tooltip="Remove" href="javascript:void(0);" (click)="openModal(template,'deletemodal',prop.Guid,prop.PropertyName,i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                    </td>
                    <td [hidden]="true"><p class="d-flex">{{prop.PropertySequenceId}}</p></td>
                    <td style="position:relative;" class="pro-img-td hidden-xs">
                      <p class="d-flex">
                        <span style="position:static;margin-right:5px;" *ngIf="prop.IsPortfolio" (click)="showPortfolioProperties(prop.Id, i)" class="btn-collapse" [class.span-open]="this.propertiesEx[i].ShowPortfolioProperties">
                          <i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                        <a href="#" routerLink="/viewproperty/{{prop.Slug ? prop.Slug : prop.Guid}}" (click)="onRedirection();" [queryParams]="{ prevroute:'Archive' , link:'archive-view'}">{{ prop.PropertyName }}</a>
                        <a href="javascript:void(0);" class="blueone" *ngIf="prop.HasDuplicate" tooltip="View Duplicates" (click)="openModalForDuplicates(DuplicateProperty,'panlestyle',prop.Id)" placement="top" style="line-height:32px;">
                          <i class="fa fa-files-o" style="font-size:18px;" aria-hidden="true"></i>
                        </a>
                      </p><sub>{{prop.PropertySequenceId}}</sub>
                    </td>

                    <td [hidden]="hideColumn(1)"><p>{{ prop.State ? prop.State : '-'}}</p></td>
                    <td [hidden]="hideColumn(2)"><p>{{ prop.City ? prop.City : '-'}}</p></td>
                    <td [hidden]="hideColumn(3)">
                      <p>
                        <span *ngIf="prop.AssociatedBrokers!=null" container="body" triggers="mouseenter:mouseleave" popover="{{ prop.AssociatedBrokers ? prop.AssociatedBrokers : '-' }}">{{ prop.BrokerCount ? prop.BrokerCount : '-' }}</span>
                        <span *ngIf="prop.AssociatedBrokers==null">{{ prop.BrokerCount ? prop.BrokerCount : '-' }}</span>
                      </p>
                    </td>

                    <td [hidden]="hideColumn(4)"><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract','not-available':prop.PropertyStatus === 'Not Available','Off-Market':prop.PropertyStatus === 'Off-Market'}">{{ prop.PropertyStatus }}</p></td>
                    <td [hidden]="hideColumn(5)" *ngIf="prop.Unpriced">Unpriced</td>
                    <td [hidden]="hideColumn(5)" *ngIf="!prop.Unpriced"><p class="whitespacenowrap">{{(prop.Price!=null&&prop.Price>=0) ? '$ '+ (prop.Price | number:0) : '-'}}</p></td>
                    <td [hidden]="hideColumn(6)"><p class="whitespacenowrap">{{(prop.RentNOI) ? '$ '+ (prop.RentNOI | number:0) : '-'}}</p></td>

                    <td [hidden]="hideColumn(7)"><p>{{ prop.Rating ? prop.Rating  : '-' }}</p></td>
                    <td *ngIf="prop.capRateText == 'ZCF'" [hidden]="hideColumn(8)"><p>{{prop.capRateText}}</p></td>
                    <td *ngIf="prop.capRateText != 'ZCF'" [hidden]="hideColumn(8)"><p class="whitespacenowrap">{{ prop.CapRate ? prop.CapRate + '%' : '-'}}</p></td>
                    <!--<td><p class="whitespacenowrap">{{ prop.RemainingTerm ? (prop.RemainingTerm | yearsMonthConverter:true) : '-'}}</p></td>-->

                    <td [hidden]="hideColumn(9)"><p class="whitespacenowrap">{{ prop.Remaining_Term ? prop.Remaining_Term : '-'}}</p></td>
                    <td [hidden]="hideColumn(10)"><p class="whitespacenowrap">{{ prop.LeaseStructure ? prop.LeaseStructure : '-'}}</p></td>
                    <td [hidden]="hideColumn(11)"><p class="whitespacenowrap">{{ prop.BuildingSize ? (prop.BuildingSize | number:0) : '-' }}</p></td>
                    <td [hidden]="hideColumn(12)"><p>{{ prop.Rank }}</p></td>
                  </tr>
                  <ng-container *ngIf="this.propertiesEx[i].ShowPortfolioProperties">
                    <tr *ngFor="let propChild of prop.PortfolioProperties; let k=index" (click)="selecteRow(k)" [class.tr-collapse]="this.propertiesEx[i].ShowPortfolioProperties">
                      <td></td>
                      <td *ngIf="authService.Admin() || authService.SuperAdmin() || this.authService.IsUserRole(this.authService.UserRole.Broker)"></td>
                      <td [hidden]="true"><p class="d-flex">{{propChild.PropertySequenceId}}</p></td>
                      <td class="sticky-left">
                        <p><a routerLink="/viewproperty/{{propChild.Slug ? propChild.Slug : propChild.Guid}}" (click)="onRedirection();" [queryParams]="{ prevroute:'Archive' , link:'archive-view'}">{{ propChild.PropertyName }}</a></p><sub>{{propChild.PropertySequenceId}}</sub>

                      </td>
                      <!--<td [hidden]="!enableMessage"><a class="blueone" [ngClass]="{'newnote': prop.UnReadMessageCount!=0}" (click)="openMessageTab(templateMessageTab,'panlestyle messagepanel',prop)"><i class="icon-chat icon"></i></a></td>-->
                      <td [hidden]="hideColumn(1)"><p>{{ propChild.State ? propChild.State : '-' }}</p></td>
                      <td [hidden]="hideColumn(2)"><p>{{ propChild.City ? propChild.City : '-' }}</p></td>
                      <td [hidden]="hideColumn(3)"> - </td>
                      <td [hidden]="hideColumn(4)"><p [ngClass]="{'redtextlabel':(propChild.PropertyStatus === 'Closed' || propChild.PropertyStatus === 'Sold'),'greentextlabel':propChild.PropertyStatus === 'Available','orangetextlabel':propChild.PropertyStatus === 'Under Contract','not-available':propChild.PropertyStatus === 'Not Available','Off-Market':propChild.PropertyStatus === 'Off-Market'}">{{ propChild.PropertyStatus }}</p></td>
                      <td [hidden]="hideColumn(5)">
                        <p class="whitespacenowrap" *ngIf="propChild.Unpriced">Unpriced</p>
                        <p class="whitespacenowrap" *ngIf="!propChild.Unpriced">{{(propChild.Price!=null&&propChild.Price>=0 && propChild.IsShowPrice) ? '$ '+(propChild.Price |number:0) : '-'}}</p>
                      </td>
                      <td [hidden]="hideColumn(6)"><p class="whitespacenowrap">{{ (propChild.RentNOI) ? '$ '+(propChild.RentNOI | number:0) : '-' }}</p></td>
                      <td [hidden]="hideColumn(7)"><p>{{ propChild.Rating ? propChild.Rating : '-' }}</p></td>
                      <td [hidden]="hideColumn(8)"><p>{{ (propChild.CapRate && propChild.IsShowPrice) ? (propChild.CapRate | number : '1.2-2') + '%' : '-'}}</p></td>
                      <td [hidden]="hideColumn(9)"><p class="whitespacenowrap">{{ propChild.RemainingTerm ? (propChild.RemainingTerm | yearsMonthConverter:true) : '-'}}</p></td>
                      <td [hidden]="hideColumn(10)"><p class="whitespacenowrap">{{ propChild.LeaseStructure ? propChild.LeaseStructure : '-'}}</p></td>
                      <td [hidden]="hideColumn(11)"><p>{{ propChild.BuildingSize ? (propChild.BuildingSize |number:0) : '-' }}</p></td>
                      <td [hidden]="hideColumn(12)"><p>{{ propChild.Rank }}</p></td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
              <tfoot>
                <tr *ngIf="propertiesEx?.length == 0&&!IsLoading">
                  <td colspan="15" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      <!--<button class="right-btn btn  btn-circle btn-green margin-bottom" [routerLink]="['/property']" ng-reflect-placement="top" ng-reflect-tooltip="Assign Property" placement="top" tooltip="Add Property"><i aria-hidden="true" class="icofont icofont-plus icon"></i></button>
      <button class="right-btn btn  btn-green margin-bottom" [routerLink]="['/propertyimport']" ng-reflect-placement="top" ng-reflect-tooltip="Import Property" placement="top" tooltip="Import Property">Import</button>-->

    </div>
  </div>
</div>


<ng-template #bulkAction>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Change Status</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">
        Change Status of selected {{getSelectedCount()}} properties
        <span class="star">*</span>
      </label>
      <label class="select">
        <select [(ngModel)]="statusToChange" #propStatus="ngModel" class="form-control">
          <option value="0">--Select--</option>
          <option [ngValue]="item.id" *ngFor="let item of propertyStatusList">{{item.description}}</option>
        </select>
        <i></i>
      </label>
      <p class="redtext" *ngIf="showSelectStatus || (propStatus.touched && statusToChange == 0)">Please select status</p>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="changeStatus();">Update</button>
    </div>
  </div>

</ng-template>


<ng-template #CompOrArchive>

  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ConfirmationHeading}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">{{confirmBody}}</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="markCompOrArchive();modalRef.hide();">Update</button>
    </div>
  </div>

</ng-template>

<ng-template #DuplicateProperty>
  <app-duplicate-property-list [PropertyId]="selectedPropertyIdForDuplicates" [prevRoute]="'Archived'" [modalRef]="modalRefDuplicate" [Type]="1"></app-duplicate-property-list>
</ng-template>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Property ?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefRemove.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete {{property}} ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefRemove.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteProperty();modalRefRemove.hide();">Delete</button>
    </div>
  </div>
</ng-template>
